module.exports = __webpack_public_path__ + "static/media/aquearium.ae5bd566.png";